import initialState from './initial.state';
import * as types from '../actions/types.action';

const emptyLookup = {
  loading: false,
  found: false,
  companyNumber: null,
  companyName: null,
  companyStatus: null,
  registeredAddress: null,
  error: null,
};

export default function creditTermsReducer(
  state = initialState.creditTerms,
  action
) {
  switch (action.type) {
    case types.APPLY_FOR_CREDIT_SUCCESS:
      return Object.assign({}, state, {
        outcome: action.outcome,
        responseWorkingDays: action.responseWorkingDays || null,
      });
    case types.APPLY_FOR_CREDIT_REQUESTED:
    case types.RESET_CREDIT_APPLICATION:
      return Object.assign({}, state, {
        outcome: null,
        responseWorkingDays: null,
      });
    case types.LOOKUP_COMPANY_REQUESTED:
      return Object.assign({}, state, {
        companyLookup: Object.assign({}, emptyLookup, {loading: true}),
      });
    case types.LOOKUP_COMPANY_SUCCESS:
      return Object.assign({}, state, {
        companyLookup: {
          loading: false,
          found: true,
          companyNumber: action.company.companyNumber,
          companyName: action.company.companyName,
          companyStatus: action.company.companyStatus,
          registeredAddress: action.company.registeredAddress,
          error: null,
        },
      });
    case types.LOOKUP_COMPANY_NOT_FOUND:
      return Object.assign({}, state, {
        companyLookup: Object.assign({}, emptyLookup, {found: false}),
      });
    case types.LOOKUP_COMPANY_FAILED:
      return Object.assign({}, state, {
        companyLookup: Object.assign({}, emptyLookup, {error: action.message}),
      });
    case types.RESET_COMPANY_LOOKUP:
      return Object.assign({}, state, {companyLookup: emptyLookup});
    default:
      return state;
  }
}
